/*
 * @FilePath: /mall-fe/src/views/Index.cscec3b.tsx
 * @Description: cscec3b 商城首页门户入口页面
 *
 */
import { getFloor, getFloorV2 } from '@/api/std';
import { getBanner } from '@/api/user';
import { apiQueryWaybillTrackList } from 'api/logistics';
import Layout from 'comps/Layout';
import { SiteContext, UserContext } from 'libs/contexts';
import { BANNER_TYPE_ENUM, CurrentUserTypeSource, FloorType, UserSource } from 'libs/enums';
import { useContext, useEffect, useState } from 'react';
import IndexMobile from './IndexMobile';

/**
 *
 * @param {object} floorsData 楼层数据
 * @param {object} bannersData 广告位数据
 * @param {object} brandsData 品牌数据
 * @param {object} skuStatisticsData 商品统计数据
 * @param {object} hotData 热点商品数据
 * @param {object} recommendData 推荐商品数据
 * @param {object} bulletinData 公共数据
 * @param {object} categorys 商品分类
 * @param {object} newIndexFloorsData 楼层商品数据
 * @param {object} newIndexRecommendData 首次推荐商品数
 * @param {object} newIndexHotData 首层热点商品
 * @param {object} newIndexBannerData 首页品牌数据
 * @param {object} newIndexBulletinData 公共信息
 * @param {object} hireBannerData 雇佣广告数据
 * @param {object} outwardHireBannerData 外租广告位
 * @returns
 */
const Index = ({ isMniprogramEnv, isQywx }: any) => {
  const site = useContext(SiteContext);
  const userInfo = useContext(UserContext);
  const isNewHome =
    !userInfo ||
    userInfo?.organizationSource === UserSource.outside ||
    userInfo.currentUserType === CurrentUserTypeSource.personal;

  const [floorsData, setFloorsData] = useState([]);
  const [bannersData, setBannersData] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [hotData, setHotData] = useState([]);
  const [recommendData, setRecommendData] = useState([]);
  const [hireBannerData, setHireBannerData] = useState([]);
  const [newIndexHotData, setNewIndexHotData] = useState([]);
  const [newIndexFloorsData, setNewIndexFloorsData] = useState([]);
  const [newIndexRecommendData, setNewIndexRecommendData] = useState([]);
  const [newIndexBannerData, setNewIndexBannerData] = useState([]);
  const [logisticsCount, setLogisticsCount] = useState(0)

  useEffect(() => {
    (async () => {
      const res = await getBanner(BANNER_TYPE_ENUM.ZJ3_MALL_INDEX_MOBILE);
      if (res?.data) {
        setBannersData(res.data);
      }
    })();
    (async () => {
      const res = await getFloorV2(FloorType.Index);
      if (res?.data) {
        setFloorsData(res.data);
      }
    })();
    (async () => {
      const res = await getFloor(FloorType.IndexBrandsMobile);
      if (res?.data) {
        setBrandsData(res.data);
      }
    })();
    (async () => {
      const res = await getFloorV2(FloorType.ZJ3_HOT_SALE_SKU);
      if (res?.data) {
        setHotData(res.data);
      }
    })();
    (async () => {
      const res = await getFloorV2(FloorType.ZJ3_RECOMMEND_SHOP);
      if (res?.data) {
        setRecommendData(res.data);
      }
    })();
    (async () => {
      const res = await getBanner(BANNER_TYPE_ENUM.ZJ3_HIRE_BANNER_H5);
      if (res?.data) {
        setHireBannerData(res.data);
      }
    })();
    (async () => {
      const res = await getFloorV2(FloorType.ZJ3_HOT_SALE_SKU_NEW);
      if (res?.data) {
        setNewIndexHotData(res.data);
      }
    })();
    (async () => {
      const res = await getFloorV2(FloorType.ENTERPRISE_WISE_SELECTION_NEW);
      if (res?.data) {
        setNewIndexFloorsData(res.data);
      }
    })();
    (async () => {
      const res = await getFloorV2(FloorType.ZJ3_RECOMMEND_SHOP_NEW);
      if (res?.data) {
        setNewIndexRecommendData(res.data);
      }
    })();
    (async () => {
      const res = await getBanner(BANNER_TYPE_ENUM.ZJ3_NEW_HOME_BANNER);
      if (res?.data) {
        setNewIndexBannerData(res.data);
      }
    })();
    (async () => {
      if (!userInfo?.isPurchaser) return
      const res = await apiQueryWaybillTrackList({
        firstFive: false
      })
      if (res?.data) {
        setLogisticsCount(res.data.count)
      }
    })();
  }, []);

  return (
    <Layout
      header={null}
      footer={null}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description={`${
        site?.basic?.tenantName || ''
      }通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
      showFixedMenu
      bgColor="#ffffff"
    >
      <IndexMobile
        {...{
          isQywx,
          isMniprogramEnv,
          floorsData: isNewHome ? newIndexFloorsData : floorsData,
          bannersData: isNewHome ? newIndexBannerData : bannersData,
          brandsData,
          hotData: isNewHome ? newIndexHotData : hotData,
          recommendData: isNewHome ? newIndexRecommendData : recommendData,
          hireBannerData,
          logisticsCount,
        }}
      />
    </Layout>
  );
};

export default Index;
